import { ViewChild, ViewContainerRef, ComponentRef, Component } from '@angular/core';
import { BaseViewUI } from './BaseViewUI/BaseViewUI';

/**
 * BasePanel
 *
 * タブの中身パーツのベースクラス
 * これを継承するコンポーネントは、タブの中身の想定
 * HACK: 検索ボックスが邪魔になってきてるので、あとでBaseTabSearchとかにして、検索機能を下にさげる。

 */
 @Component({
	template: ''
  })
export abstract class BasePanelComponent extends BaseViewUI {

	// 下記の2つの差し込み場所は、継承する側で、テンプレート中に共通で用意しておく。
	// 検索Boxのコンテナ
	@ViewChild('searchboxContainer', { read: ViewContainerRef, static: false })
	public insideSearchBoxContainer: ViewContainerRef;
	// テーブルのコンテナ
	@ViewChild('tableContainer', { read: ViewContainerRef, static: false })
	public insideTableContainer: ViewContainerRef;

	// インスタンスの保持
	public insideSearchBoxInst: any;	// 検索ボックスコンポーネント
	public insideListTableInst: any;	// テーブルコンポーネント

	// テーブルの表示月の選択値プロパティ。各タブで変更された場合に設定される。
	public selectedMonth: string;

	// 親クラスで設定された表示月。
	// このデータはHTML上のselectタブに双方向でバインドされてる。
	public bindSelectedMonth: string;


	// コンポーネントとコントローラーの結合用プロパティは、継承関係上の上書きする。
	// F12での参照が出来うようにする為と、クラス構造で、どのコントローラーと紐づくか明示する為。
	public combineCtrl: any;


	/**
	 * setViewPartsData
	 * 検索ボックスとテーブルを作って、データをセットするメソッドを呼んで表示準備。
	 *
	 * @param searchBox 検索ボックスのパーツクラス
	 * @param tableParts テーブルのパーツクラス
	 */
	public createTableViewParts(searchBox: any, tableParts: any) {

		// 表と連動する検索ボックスの２つを作って差し込む
		// HACK: 生成の順番を変更したいが、表示上差し込まれる順番は検索ボックスが先じゃないと駄目

		// 検索ボックスのコンポーネントを作成して参照を保持
		this.insideSearchBoxInst = this.createStartComponent(searchBox, this.insideSearchBoxContainer);

		// テーブルのコンポーネントを作成して参照を保持
		this.insideListTableInst =	this.createStartComponent(tableParts, this.insideTableContainer);

	}

	/**
	 * setTableListData
	 * テーブルにデータをセット
	 *
	 * @param tableData 表示したいデータ
	 */
	public setTableListData( tableData: any ) {

		if (this.insideListTableInst) {
			this.insideListTableInst.setListTableData(tableData);
		}

	}

	/**
	 * createTableParts
	 * テーブルだけを作成する
	 *
	 * @param tableParts テーブルのパーツクラス
	 */
	public createTableParts(tableParts: any) {

		// テーブルのコンポーネントを作成して参照を保持
		this.insideListTableInst = this.createStartComponent(tableParts, this.insideTableContainer);

	}


}
